<template lang="html">
<div class="pgInner">

    <div class="headBar">新建解读</div>

    <div class="pgbody" :style="'height:' + pageH + 'px;'">
         <el-scrollbar ref="scroller" style="height:100%;">



           <div class="tabContent">

             <div class="text-block clearfix">
                 <div class="bName">关联申报</div>
                 <div class="bContent">
                   <el-select class="inpText" v-model="value" placeholder="选择申报">
                     <el-option
                       v-for="item in options"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
                     </el-option>
                   </el-select>
                 </div>
             </div>

             <div class="text-block clearfix">
                 <div class="bName">解读标题</div>
                 <div class="bContent">
                   <el-input class="inpText" v-model="input" placeholder="请输入内容"></el-input>
                 </div>
             </div>

             <div class="text-block clearfix">
                 <div class="bName">发文机构</div>
                 <div class="bContent">
                   <el-input class="inpText" v-model="input" placeholder="请输入内容"></el-input>
                 </div>
             </div>

             <div class="text-block clearfix">
                 <div class="bName">缩略图</div>
                 <div class="bContent">
                     <el-radio-group v-model="radio">

                    </el-radio-group>
                 </div>
             </div>

             <div class="text-block clearfix">
                 <div class="bName">内容类型</div>
                 <div class="bContent">
                     <el-radio-group class="radioGp" v-model="radio">
                        <el-radio :label="1">文字解读</el-radio>
                        <el-radio :label="2">图片解读</el-radio>
                        <el-radio :label="3">视频解读</el-radio>
                    </el-radio-group>
                 </div>
             </div>

             <div class="text-block clearfix">
                 <div class="bName">
                     <span v-if="radio==1">文字解读</span>
                     <span v-if="radio==2">图片解读</span>
                     <span v-if="radio==3">视频解读</span>
                 </div>
                 <div v-if="radio == 1" class="bContent">
                     <editor id="editor_id" height="500px" width="100%" :content="editorText"
                     pluginsPath="/static/kindeditor/plugins/"
                     :loadStyleMode="false"></editor>
                 </div>
                 <div v-if="radio == 2" class="bContent">
                     <imgUpload />
                 </div>
                 <div v-if="radio == 3" class="bContent">
                     <mvUpload />
                 </div>
             </div>

           </div>

         </el-scrollbar>
    </div>

    <div class="pagefoot">

        <el-button type="primary" size="small">立即发布</el-button>
        <el-button type="primary" size="small">发布并新建解读</el-button>
        <el-button plain size="small">存为草稿</el-button>
        <el-button plain size="small">取消</el-button>

    </div>

</div>
</template>

<script>
import Editor from "@/components/KindEditor/KindEditor";
import mvUpload from "./upload/mvUpload";

export default {
    components:{
        mvUpload
    },
    data(){
        return{

            pageH:'',
            radio:1

        }
    },

    methods:{
      pageFix:function(){
          this.pageH = document.documentElement.clientHeight - 205;
      },
      prevSet:function(){

          // 底部定位
          this.pageFix();

      }
    },
    created:function(){
        var vues = this;

        this.prevSet();
        $(window).resize(function(){
    		     vues.pageFix();
             vues.$refs.scroller.$data.sizeHeight = this.pageH;
    	  })

    }


}
</script>

<style lang="scss" scoped>

.pgInner{
  background: #f5f5f5;
}

.headBar{
  height: 55px;
  line-height: 55px;
  font-size: 16px;
  padding-left: 20px;
  background: white;
}

.pgbody{
  margin: 20px;
}

.tabContent{
  padding: 20px;
  background: white;
}

.pagefoot{
  height: 60px;
  line-height: 60px;
  background: white;
  padding-left: 20px;
  position: relative;
  z-index: 2;
  .btn{
    height: 32px;
    padding: 0 12px;
    margin-right: 12px;
    display: inline-block;
    font-size: 14px;
    cursor: pointer;
  }
  .type1{
    line-height: 32px;
    background: rgb(86, 119, 252);
    color: white;
  }
  .type2{
    box-sizing: border-box;
    border: 1px solid #aeaeae;
    line-height: 30px;
  }
}

.text-block{
      font-size: 14px;
     .bName{
          width: 80px;
          padding-top: 8px;
          float: left
     }
     .bContent{
          margin-left: 80px;
          position: relative;
          margin-bottom: 20px;

          .inpText{
              width: 300px;
          }

          .radioGp{
              line-height: 50px;
          }

     }

}

</style>



// WEBPACK FOOTER //
// unscramble.vue?3cf05809